import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const TimeDropdown = ({ heading }) => {
  const dropdownPeriodRef = useRef(null);
  const [dropdownPeriodOpen, setDropdownPeriodOpen] = useState(false);

  const handleClickPeriodOutside = (event) => {
    if (
      dropdownPeriodRef.current &&
      !dropdownPeriodRef.current.contains(event.target)
    ) {
      // Clicked outside the dropdown, so close it
      setDropdownPeriodOpen(false);
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickPeriodOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickPeriodOutside);
    };
  }, []);

  return (
    <div
      className="font-medium relative cursor-pointer w-44"
      ref={dropdownPeriodRef}
    >
      <div
        className="text-sm bg-white  px-2 py-1 text-center text-black flex items-center justify-between rounded-md border border-[#C7C7C7]"
        onClick={() => setDropdownPeriodOpen(!dropdownPeriodOpen)}
      >
        <span className="overflow-hidden whitespace-nowrap text-ellipsis">
          {heading}
        </span>
        <IoIosArrowDown />
      </div>
      <div
        className={`bg-white absolute border border-lite-grey-4 right-0 rounded-md z-20 mt-[3px] ${
          dropdownPeriodOpen ? "block" : "hidden"
        }`}
      >
        <ul className="z-10 bg-white max-h-[200px] overflow-y-auto rounded-lg w-44">
          <li className="sort-list-items">Hourly</li>
          <li className="sort-list-items">Daily</li>
          <li className="sort-list-items">Weekly</li>
          <li className="sort-list-items">Monthly</li>
        </ul>
      </div>
    </div>
  );
};

export default TimeDropdown;
